import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const patchAnnotationsTE = (
  userId: string,
  appId: string,
  body: {
    annotations: Partial<CF.API.Annotations.Annotation>[];
    action: 'overwrite' | 'merge' | 'remove';
  },
): TaskEither<CF.API.BaseResponse, CF.API.Annotations.PostAnnotationsResponse> => {
  return fetchTE({
    path: `/api/_api/v2/users/${userId}/apps/${appId}/annotations`,
    method: 'PATCH',
    body,
  });
};
